import React from "react";
import { Menu, PhoneCall, Instagram, Settings } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "../components/ui/sheet";

export const Header = ({ onNavClick, whatsapp, instagram }) => {
  const navigate = useNavigate();

  const NavLinks = () => (
    <nav className="hidden md:flex items-center gap-8 text-sm font-medium">
      <a href="#servicos" onClick={onNavClick} className="hover:opacity-80 transition-opacity">Serviços</a>
      <a href="#destaques" onClick={onNavClick} className="hover:opacity-80 transition-opacity">Destaques</a>
      <a href="#faq" onClick={onNavClick} className="hover:opacity-80 transition-opacity">FAQ</a>
      <a href="#contato" onClick={onNavClick} className="hover:opacity-80 transition-opacity">Contato</a>
      <button onClick={() => window.location.hash = '#/config'} className="text-white/60 hover:text-white flex items-center gap-1"><Settings className="w-4 h-4" /> Config</button>
    </nav>
  );

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mt-4 backdrop-blur-xl bg-[rgba(13,27,42,0.6)] border border-white/10 rounded-2xl shadow-xl">
          <div className="flex items-center justify-between px-4 py-3">
            <a href="#top" className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-lg bg-yellow-400/90 ring-4 ring-yellow-400/20 shadow-[0_0_30px_rgba(250,204,21,0.4)]" />
              <div className="leading-tight">
                <span className="block text-xs tracking-widest text-white/80">FÁBRICA</span>
                <span className="block text-xl font-extrabold text-white">HÉRCULES</span>
              </div>
            </a>

            <NavLinks />

            <div className="hidden md:flex gap-2">
              <Button asChild size="sm" className="bg-yellow-400 text-black hover:bg-yellow-300">
                <a href={whatsapp} target="_blank" rel="noreferrer">
                  <PhoneCall className="w-4 h-4 mr-2" /> WhatsApp
                </a>
              </Button>
              <Button asChild size="sm" variant="outline" className="border-white/20 text-white hover:bg-white/10">
                <a href={instagram} target="_blank" rel="noreferrer">
                  <Instagram className="w-4 h-4 mr-2" /> Instagram
                </a>
              </Button>
            </div>

            <div className="md:hidden">
              <Sheet>
                <SheetTrigger asChild>
                  <Button size="icon" variant="outline" className="border-white/20 text-white hover:bg-white/10">
                    <Menu className="w-5 h-5" />
                  </Button>
                </SheetTrigger>
                <SheetContent side="right" className="bg-[#0b1b34] text-white border-l border-white/10">
                  <SheetHeader>
                    <SheetTitle className="text-white">Navegação</SheetTitle>
                  </SheetHeader>
                  <div className="mt-6 flex flex-col gap-4">
                    <a href="#servicos" className="py-2 border-b border-white/10">Serviços</a>
                    <a href="#destaques" className="py-2 border-b border-white/10">Destaques</a>
                    <a href="#faq" className="py-2 border-b border-white/10">FAQ</a>
                    <a href="#contato" className="py-2 border-b border-white/10">Contato</a>
                    <button onClick={() => window.location.hash = '#/config'} className="py-2 text-left">Config</button>
                    <div className="flex gap-2 pt-4">
                      <Button asChild className="bg-yellow-400 text-black hover:bg-yellow-300">
                        <a href={whatsapp} target="_blank" rel="noreferrer">
                          <PhoneCall className="w-4 h-4 mr-2" /> WhatsApp
                        </a>
                      </Button>
                      <Button asChild variant="outline" className="border-white/20 text-white hover:bg-white/10">
                        <a href={instagram} target="_blank" rel="noreferrer">
                          <Instagram className="w-4 h-4 mr-2" /> Instagram
                        </a>
                      </Button>
                    </div>
                  </div>
                </SheetContent>
              </Sheet>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
